import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie-service';
import { AdminOrderDetail } from '../../models/purchaseorder/create-purchase-order.model';
import { AdminOrder } from '../../models/purchaseorder/create-purchase-order.model';
import { BulkChangeOrderStatus } from '../../models/order/order.model';

@Injectable()
export class PurchaseOrderService {
  private service = "api/Order"; //Controller Name
  private serviceUtility = "api/Utility"; //Controller Name
  public OrderList: AdminOrder[];
  constructor(private http: Http,
    private readonly router: Router,
    private cookieService: CookieService) { }

  GetPurchaseOrders() {
    return this.http.get(`${this.service}/GetPurchaseOrders`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetPurchaseOrderDetailByID(id: string) {
    return this.http.get(`${this.service}/GetPurchaseOrder?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }


  GetPurchaseOrdersGrid(pageNumber: number, pageSize: number, searchKeyword: string) {
    return this.http.get(`${this.service}/GetPurchaseOrdersGrid?pageNumber=` + pageNumber + `&pageSize=` + pageSize + `&searchKeyword=` + searchKeyword, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetSinglePurchaseOrdersReport(vendorID: number, dateFrom: string, dateTo: string) {
    return this.http.get(`${this.service}/SinglePurchaseOrderReport?vendorID=` + vendorID + `&dateFrom=` + dateFrom + `&dateTo=` + dateTo, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetMultiPurchaseOrdersReport(dateFrom: string) {
    return this.http.get(`${this.service}/MultiplePurchaseOrderReport?dateFrom=` + dateFrom , {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  PrintOrder(orderStatus: BulkChangeOrderStatus) {
    //Todo
    return this.http.put(`${this.service}/PrintPurchaseOrder`, orderStatus, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/purchase-order/purchase-order.service.ts